export class CpfValidator {
  static validate(cpf: string): boolean {
    // Remove caracteres não numéricos
    cpf = cpf.replace(/[^\d]/g, '');

    // Verifica se o CPF tem 11 dígitos
    if (cpf.length !== 11) return false;

    // Verifica se todos os dígitos são iguais
    if (/^(\d)\1+$/.test(cpf)) return false;

    // Cálculo do primeiro dígito verificador
    let sum = 0;
    for (let i = 0; i < 9; i++) {
      sum += parseInt(cpf.charAt(i)) * (10 - i);
    }
    let remainder = 11 - (sum % 11);
    let checkDigit1 = remainder >= 10 ? 0 : remainder;

    // Verifica primeiro dígito verificador
    if (checkDigit1 !== parseInt(cpf.charAt(9))) return false;

    // Cálculo do segundo dígito verificador
    sum = 0;
    for (let i = 0; i < 10; i++) {
      sum += parseInt(cpf.charAt(i)) * (11 - i);
    }
    remainder = 11 - (sum % 11);
    let checkDigit2 = remainder >= 10 ? 0 : remainder;

    // Verifica segundo dígito verificador
    return checkDigit2 === parseInt(cpf.charAt(10));
  }
}
